import { ReactNode } from "react";
import { Authority, getCurrentAuthority } from "../../utils/permissions";

interface RoleGuardProps {
  allow?: Authority[];   // whitelist — only these roles see children
  deny?: Authority[];    // blacklist — these roles never see children
  children: ReactNode;
  fallback?: ReactNode;  // optional: render something else instead (e.g. disabled button)
}

const RoleGuard = ({ allow, deny, children, fallback = null }: RoleGuardProps) => {
  const authority = getCurrentAuthority();

  if (deny && authority && deny.includes(authority)) return <>{fallback}</>;
  if (allow && (!authority || !allow.includes(authority))) return <>{fallback}</>;

  return <>{children}</>;
};

export default RoleGuard;